module.exports = __webpack_public_path__ + "img/_4.a9c99390.png";